import styled, { FlattenSimpleInterpolation, css } from 'styled-components';

import { Color, FontWeight, InputTheme, ZIndex } from '../../../enums';
import { StyledComponent } from '../../../interfaces';

import { LabelProps } from './inputContainer.types';

export const InputLabelBaseComponent: StyledComponent<'label', LabelProps> = styled.label<LabelProps>`
  position: absolute;
  top: ${({ $inputTheme }: LabelProps): string => $inputTheme === InputTheme.Small ? '12px' : '18px'};
  left: 16px;
  transition: 0.2s;
  font-size: ${({ $inputTheme }: LabelProps): string => $inputTheme === InputTheme.Small ? '14px' : '16px'};
  line-height: 22px;
  color: ${Color.Gray500};
  pointer-events: none;
  background-color: ${Color.White};
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: ${({ $hasSmallerWidth, $withIcon }: LabelProps) => $hasSmallerWidth || $withIcon ? 'calc(100% - 60px)' : 'calc(100% - 18px)'};
  ${({ $disabled }: LabelProps): string | false => !!$disabled && `background-color: ${Color.Transparent}`};

  ${({ $isOnTop, $topPartBackground }: LabelProps): string | false => !!$isOnTop
    && `
      top: 0;
      transform: translateY(-50%);
      font-size: 12px;
      line-height: 16px;
      padding: 4px;
      margin-left: -4px;
      width: fit-content;
      max-width: 100%;

      &::after {
        content: '';
        background: ${$topPartBackground ? $topPartBackground : 'none'};
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 50%;
        z-index: ${ZIndex.Min};
      }
  `}
`;

export const InputLabelSpan: StyledComponent<'span'> = styled.span`
  display: block;
  position: relative;
  z-index: ${ZIndex.InputLabelSpan};
`;

export const InputValueBoxBaseStyle: FlattenSimpleInterpolation = css`
  font-size: 16px;
  line-height: 22px;
  color: ${Color.Gray500};
  padding: 0 16px;
  height: 58px;
  width: 100%;
  transition: 0.3s;
  border: 1px solid ${Color.Stroke};
  font-weight: ${FontWeight.Light};
  display: flex;
  align-items: center;
  background-color: ${Color.White};
  z-index: ${ZIndex.Min};

  &:hover:not(:disabled):not(:focus) {
    border-color: ${Color.Gray400};
  }

  &:focus {
    border-color: ${Color.Error500};
    color: ${Color.Black};
  }

  &:disabled {
    background-color: ${Color.Gray200};
    border-color: ${Color.Gray300};
  }
`;
